import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import backgroundImage from '../../assets/images/pvx-home-bg.png';
import { NAV_ROUTES } from '../../constants/navRoutes';
import { useTranslation } from 'react-i18next';

const PageNotFound: FC = () => {
  const navigate = useNavigate();
  const { t: translations } = useTranslation();

  // Hook to redirect to home page on invalid path
  useEffect(() => {
    setTimeout(() => {
      navigate(NAV_ROUTES.HOME);
    }, 10000);
  }, [navigate]);

  return (
    <>
      <Box
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#FFFFFF',
          textAlign: 'center',
        }}
      >
        <div>
          <h1>{translations('common.page_not_found')}</h1>
          <p>{translations('common.redirecting')}</p>
        </div>
      </Box>
    </>
  );
};

export default PageNotFound;
